export default __webpack_public_path__ + "static/media/cp_geo_ly.f93c267c.svg";